module.exports = __webpack_public_path__ + "img/rightwireicon.23b9821c.png";